/* eslint-disable import/extensions */
/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
import React, { ReactElement, ReactChild } from "react";
import styled from "styled-components";

import { theme } from "../theme/theme";

import Chip from "./chip";

type ChipData = {
  title: string;
  variant:
    | "blue"
    | "gradient"
    | "grayDark"
    | "grayLight"
    | "grayMedium"
    | "green"
    | "orange"
    | "purple"
    | "red"
    | "white"
    | "whiteOnRed"
    | "yellow"
    | "yellowDark";
};

type CardProps = {
  children: ReactChild;
  title: string;
  chipData?: ChipData[];
};

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;

  background: ${theme.color.white};

  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(46, 53, 56, 0.25);
`;

const StyledTop = styled.div`
  padding: 0px 32px 16px 32px;
  border-bottom: 1px solid ${theme.color.grayLightest};

  font-family: ${theme.fontFamily};
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;

  color: ${theme.color.black};
  display: flex-column;
`;

const StyledBottom = styled.div`
  padding: 32px;
`;

const StyledChipWrapper = styled.div`
  padding: 32px 0px 16px 0px;
`;

const StyledChip = styled(Chip)`
  margin: 0px 12px 0px 0px;
`;

const Card = ({ children, title, chipData }: CardProps): ReactElement => {
  return (
    <StyledCard>
      <StyledTop>
        <StyledChipWrapper>
          {chipData.map((chip, i) => {
            return (
              <StyledChip key={i} variant={chip.variant}>
                {chip.title}
              </StyledChip>
            );
          })}
        </StyledChipWrapper>
        {title}
      </StyledTop>
      <StyledBottom> {children} </StyledBottom>
    </StyledCard>
  );
};

Card.defaultProps = {
  chipData: [],
};

export default Card;
